import $ from 'jquery';
import plugin from '@core/plugins/lib';
import CartCount from './cart-count';

const ELEMENT_SELECTOR = '[data-cart-count]';
const PLUGIN_NAME = 'CartCount';

plugin(PLUGIN_NAME, CartCount);

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--cart-count" */ './cart-count'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/cart-count/plugin--split.js